/**
 * Created by Allan on 2021/04/26.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/product',
        meta:{
            title:'产品管理',
            icon:'el-icon-menu',
            menuId:'9'
        },
        component:Frame,
        children:[
            {
                path:'index',
                name:'productList',
                meta:{
                    title:'产品列表',
                    keepAlive:true,
                    menuId:'11'
                },
                component:resolve => require(['@/views/product/list/index'], resolve)
            },
            {
                path:'operate/:state',
                name:'producOperate',
                meta:{
                    title:'操作',
                },
                hidden:true,
                component:resolve => require(['@/views/product/operate/index'], resolve)
            },
            {
                path:'pay',
                name:'productPay',
                meta:{
                    title:'支付管理',
                    keepAlive:true,
                    menuId:'81'
                },
                component:resolve => require(['@/views/product/payment/list/index'], resolve)
            },
            {
                path:'pay/operate',
                name:'payOperate',
                meta:{
                    title:'支付通道修改',
                    keepAlive:false,
                },
                hidden:true,
                component:resolve => require(['@/views/product/payment/operate/index'], resolve)
            },
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/product.js